class UIAccordionGroup {
    constructor(el, singleOpen = true) {
        this.el = el;
        this.singleOpen = singleOpen;
        this.accordions = [];

        this.currentlyOpen = null;

        this.listenClose();
        this.listenOpen();
    }

    static init(singleOpen = true) {
        const groups = document.querySelectorAll('.ui-accordion__group');
        if (!groups.length) return;

        groups.forEach((group) => {
            const accordionGroup = new UIAccordionGroup(group, singleOpen);
            group.UIAccordionGroup = accordionGroup; // eslint-disable-line
        });
    }

    addAccordion(accordion) {
        this.accordions = { ...this.accordions, [accordion.ID]: accordion };
    }

    closeCurrent() {
        if (!this.singleOpen) return;

        const { accordions } = this;
        const current = this.el.getAttribute('data-open');
        if (current && accordions[current]) accordions[current].close();
    }

    closeAll() {
        if (this.accordions.length === 0) return;

        this.accordions.forEach((accordion) => {
            accordion.close();
        });
    }

    /** The new open accordion is managed by itself. Here we only close the other one if open */
    open(id) {
        this.closeCurrent();
        this.el.setAttribute('data-open', id);
    }

    listenOpen() {
        this.el.addEventListener('ui-accordion-group-open', ({ detail: { id } }) => {
            this.open(id);
        });
    }

    listenClose() {
        this.el.addEventListener('ui-accordion-group-close', ({ detail: { id } }) => {
            const current = this.el.getAttribute('data-open');
            if (current === id) this.el.removeAttribute('data-open');
        });
    }
}

export default UIAccordionGroup;
